


















































import Vue, { PropOptions } from 'vue';
import themes from '../../styles/themes';
import { BreadCrumb } from '../../types';

export default Vue.extend({
  name: 'SToolbarTitle',

  props: {
    /**
     * The theme colour applied to the component. Is used to work out the colours for the sub
     * title & icon
     */
    theme: {
      type: String,
      default: 'primary',
    },

    /**
     * The title text to show.
     */
    title: {
      type: String,
      required: true,
    },

    /**
     * The sub title text to show
     */
    subTitle: {
      type: String,
      required: false,
    },

    /**
     * If the icon set in the icon prop should be shown
     */
    showIcon: {
      type: Boolean,
      required: false,
    },

    /**
     * The icon to be shown when `showIcon` prop is set to true
     */
    icon: {
      type: String,
      required: false,
    },

    /**
     * An array of breadrcumb objects. The `text` property is the text the breadcrumb shows,
     * for any other properties have a look at the
     * [Vuetify Docs](https://vuetifyjs.com/en/components/breadcrumbs) for `v-breadcrumbs-item`
     */
    breadcrumbs: {
      type: Array,
      required: false,
    } as PropOptions<BreadCrumb[]>,
  },

  computed: {
    isLight(): boolean {
      return themes[this.theme]?.darkHeader;
    },

    iconColor(): string {
      return themes[this.theme]?.icon || 'accent';
    },
  },
});
